import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ActivePage from "../../../partials/active-page";
import { appName } from "../../../app.json";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import NewSiteType from "./NewSiteType";
import EditSiteType from "./EditSiteType";
import SiteTypeList from "./SiteTypeList";
import {
	GET_SITE_TYPE,
	NEW_SITE_TYPE,
	UPDATE_SITE_TYPE
} from "../../../queries/siteType.query";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";

const SiteType = ({ match }) => {
	const [newType, setNewType] = useState(false);
	const [siteType, setSiteType] = useState(null);
	const [message, setMessage] = useState(null);

	const title = "Site Type";
	const pages = [
		{
			title,
			path: match.path
		}
	];

	//Get authenticated user's authentication info
	const {
		GetToken,
		GetAuthenticatedStaff,
		IsAuthenticationError,
		LogOut
	} = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// Fetch list of Site type
	const { loading, error, data } = useQuery(GET_SITE_TYPE, {
		variables: { siteId: site && site.id }
	});

	//New Site type
	const [
		createSiteType,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(NEW_SITE_TYPE, {
		// Update cache
		update(caches, { data: { CreateSiteType } }) {
			const { GetAllSiteType } = caches.readQuery({
				query: GET_SITE_TYPE,
				variables: { siteId: site && site.id }
			});
			GetAllSiteType.docs.unshift(CreateSiteType.doc);
			caches.writeQuery({
				data: { GetAllSiteType },
				query: GET_SITE_TYPE,
				variables: { siteId: site && site.id }
			});
		}
	});

	// Update Site type
	const [UpdateSiteType, { loading: uLoading, error: uError }] = useMutation(
		UPDATE_SITE_TYPE,
		{
			onCompleted: data => {
				if (data) {
					setMessage(data.UpdateSiteType.message);
				}
			}
		}
	);

	if (error && IsAuthenticationError(error.message)) LogOut();

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{/* New Site type container */}
				{newType && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Site Type</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<AlertMessage
									message={
										cData && cData.CreateSiteType.message
									}
								/>

								<NewSiteType
									onSubmit={name => {
										createSiteType({ variables: { name } });
									}}
									onCancel={() => {
										setNewType(!newType);
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{/* Edit Site type container */}
				{siteType && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<span className="text-muted">Edit</span>{" "}
									{siteType.name}
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage message={message} />
								<EditSiteType
									currentValue={siteType && siteType.name}
									onSubmit={async name => {
										await UpdateSiteType({
											variables: { id: siteType.id, name }
										});

										setTimeout(() => {
											setSiteType(null);
											setMessage(null);
										}, 2000);
									}}
									onCancel={() => {
										setSiteType(null);
										setMessage(null);
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{/* List of Site types container */}
				<div className="col-md-10">
					<div className="card">
						<div className="card-head">
							<header>Site Type List</header>
							<div className="tools">
								<button
									onClick={() => {
										setNewType(!newType);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
									className="mdl-button mdl-js-button mdl-button--icon btn-circle btn-success"
									data-upgraded=",MaterialButton"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={loading} />
							<AlertMessage
								message={error && error.message}
								failed={true}
							/>
							{!loading && (
								<SiteTypeList
									items={data && data.GetAllSiteType.docs}
									onEdit={item => setSiteType(item)}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SiteType;
